import React from 'react';

import {v4} from 'uuid';

import {MessageExchange} from 'app/openai/components/TextEdition/MessagePanel';
import {gt} from 'app/utils/i18n';

type ToggleChatButtonProps = {
  knowledgebaseId: number;
  toggleWidget: () => void;
};

export const KnowledgebaseChat = ({
  knowledgebaseId,
  toggleWidget,
}: ToggleChatButtonProps) => {
  return (
    <MessageExchange
      initialAIMessage={gt('How can I help you today?')}
      threadId={v4()}
      chatType={'rag'}
      disabled={false}
      object_id={knowledgebaseId}
      content_type={'knowledgebase'}
      toggleMessagePanel={toggleWidget}
    />
  );
};
